/* import __COLOCATED_TEMPLATE__ from './company-billing-contacts.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { showModal } from 'sh-www/utils/modal-controls';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-company-billing-contacts';

class AdminCompanyBillingContacts extends Component {
  get className() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      this.args.class,
      this.className,
    );
  }

  @action
  addBillingContact(company) {
    showModal(this, 'company/add-billing-contact', {
      company,
      reloadBillingContacts: this.args.loadBillingContacts,
    });
  }

  @action
  deleteBillingContact(companyContact) {
    showModal(this, 'confirmation', {
      titleText: 'Delete billing contact?',
      bodyText: 'Are you sure you want to delete this billing contact?',
      actionButtonText: 'Delete',
      confirmAction: () => {
        this.args.onDeleteBillingContactTask.perform(companyContact);
      },
      cancelButtonText: 'Cancel',
    });
  }

  @action
  updateBillingContact(companyContact, newEmail) {
    if (companyContact.email != newEmail) {
      this.args.onUpdateBillingContact.perform(companyContact, newEmail);
    }
  }
}

export default AdminCompanyBillingContacts;
